import { render, staticRenderFns } from "./GamiMaltsWelcome.vue?vue&type=template&id=41794632&scoped=true"
import script from "./GamiMaltsWelcome.vue?vue&type=script&lang=js"
export * from "./GamiMaltsWelcome.vue?vue&type=script&lang=js"
import style0 from "./GamiMaltsWelcome.vue?vue&type=style&index=0&id=41794632&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41794632",
  null
  
)

export default component.exports